import { render, staticRenderFns } from "./Tickers.vue?vue&type=template&id=b940a4f4&"
import script from "./Tickers.vue?vue&type=script&lang=js&"
export * from "./Tickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports